import AlertComponent from './Alert.vue';

const Alert = {}

// Vue暴露了一个install方法，用于自定义插件
Alert.install = function (Vue) {
    // 创建一个子类
    const AlertConstructor = Vue.extend(AlertComponent);
    // 实例化这个子类
    const instance = new AlertConstructor();
    // 创建一个div元素，并把实例挂载到div元素上
    instance.$mount(document.createElement('div'));
    // 将el插入到body元素中
    document.body.appendChild(instance.$el);

    // 添加实例方法
    // alert插件的实例方法
    Vue.prototype.$alert = (msg, config) => {
        instance.type = 'info';
        instance.msg = msg;
        if (config) {
            instance.type = config.type || 'info';
            instance.hideOk = config.hideOk || false;
            instance.auto = config.auto || true;
            instance.duration = config.duration || 3000;
            instance.okText = config.okText || 'Okay';
            instance.theme = config.theme || 'dark';
        }
        instance.isShow = true;
    };
    Vue.prototype.$error = (msg, config) => {
        instance.type = 'error';
        instance.msg = msg;
        if (config) {
            instance.hideOk = config.hideOk || false;
            instance.auto = config.auto || true;
            instance.duration = config.duration || 3000;
            instance.okText = config.okText || 'Okay';
            instance.theme = config.theme || 'dark';
        }
        instance.isShow = true;
    };
}

export default Alert;


// WEBPACK FOOTER //
// ./src/components/alert/index.js